/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Subject_Option_OtherInputs */

const en_form_subject_option_other = /** @type {(inputs: Form_Subject_Option_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

const ar_form_subject_option_other = /** @type {(inputs: Form_Subject_Option_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أخرى`)
};

const bn_form_subject_option_other = /** @type {(inputs: Form_Subject_Option_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অন্যান্য`)
};

const de_form_subject_option_other = /** @type {(inputs: Form_Subject_Option_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonstiges`)
};

const es_form_subject_option_other = /** @type {(inputs: Form_Subject_Option_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro`)
};

const fr_form_subject_option_other = /** @type {(inputs: Form_Subject_Option_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre`)
};

const pt_form_subject_option_other = /** @type {(inputs: Form_Subject_Option_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro`)
};

const zh_form_subject_option_other = /** @type {(inputs: Form_Subject_Option_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他`)
};

const tr_form_subject_option_other = /** @type {(inputs: Form_Subject_Option_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diğer`)
};

const ru_form_subject_option_other = /** @type {(inputs: Form_Subject_Option_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другое`)
};

const pl_form_subject_option_other = /** @type {(inputs: Form_Subject_Option_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inne`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Form_Subject_Option_OtherInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_subject_option_other = /** @type {((inputs?: Form_Subject_Option_OtherInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Subject_Option_OtherInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_subject_option_other(inputs)
	if (locale === "bn") return bn_form_subject_option_other(inputs)
	if (locale === "de") return de_form_subject_option_other(inputs)
	if (locale === "es") return es_form_subject_option_other(inputs)
	if (locale === "fr") return fr_form_subject_option_other(inputs)
	if (locale === "pt") return pt_form_subject_option_other(inputs)
	if (locale === "zh") return zh_form_subject_option_other(inputs)
	if (locale === "tr") return tr_form_subject_option_other(inputs)
	if (locale === "ru") return ru_form_subject_option_other(inputs)
	if (locale === "pl") return pl_form_subject_option_other(inputs)
	return en_form_subject_option_other(inputs)
});